/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const compare_index_why_compare_text = () => `There are a lot of blockchains on the market. Each blockchain network comes with its unique set of features, strengths, and limitations. You need to analyze several key aspects of every protocol and then compare them with each other before selecting the right one. <br /> <br /> We strive to simplify this process by offering our unique tool to compare any two blockchains we track. The comparison includes all our metrics and allows you to quickly identify which blockchain is the best in each metric and see how big the gap is.`
